// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".brand-logo[data-v-0a0bc898]{line-height:1rem;height:100%;width:300px;margin-left:15px}.brand-logo img[data-v-0a0bc898]{height:100%;padding:.75rem}", ""]);
// Exports
module.exports = exports;
